import { ButtonView, Plugin } from "ckeditor5";

export class CustomPluginAction extends Plugin {
  private actionCallback?: (data: any) => void;
  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add("customAction", () => {
      const button = new ButtonView();

      button.set({
        label: "Custom Action",
        withText: true,
      });

      /* button.on('execute', () => {
            it (this.actionCallback) {
                this.actionCallback({
                    timestamp: new Date(),
                    content: editor.getData()
                });
            }
        }); */

      return button;
    });
  }

  public setCallback(callback: (data: any) => void) {
    this.actionCallback = callback;
  }
}
